export default "__VITE_ASSET__BAEH9lx$__"